import { useEffect, useState } from 'react';

import './Modal.scss';

const Modal = ({
    modalClass = '',
    onShouldRender = null,
    isOpen = false,
    onCancel = null,
    children,
    isModalFullScreen = false,
}) => {
    const [shouldRender, setShouldRender] = useState(isOpen);
    const [animationClass, setAnimationClass] = useState('');

    useEffect(() => {
        // if (isModalFullScreen) {
        //     if (isOpen) {
        //         setShouldRender(true);
        //         setAnimationClass('fade-in-modals-fullscreen');
        //     } else if (shouldRender) {
        //         setAnimationClass('fade-out-modals-fullscreen');
        //     }
        // } else {
        if (isOpen) {
            setShouldRender(true);
            setAnimationClass('in');
            // setTimeout(() => {
            // }, 1000);
        } else if (shouldRender) {
            setAnimationClass('out');
        }
        // }
    }, [isOpen]);

    const handleAnimationEnd = () => {
        if (!isOpen) {
            setShouldRender(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            onShouldRender?.();
        }
    }, [shouldRender]);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onCancel?.();
        }
    };

    /* Close on ESC */
    useEffect(() => {
        if (!isOpen) return;

        const handleKey = (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                e.preventDefault();
                onCancel?.();
            }
        };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [isOpen, onCancel]);

    if (!shouldRender) return null;

    /* Modal markup (via portal so it sits above rest of DOM) */
    return (
        <div
            className={`modal ${modalClass}`}>
            <div className={`modal-overlay ${animationClass === 'in' ? 'fade-in-modals-overlay' : animationClass === 'out' ? 'fade-out-modals-overlay' : ''}`} onClick={handleOverlayClick}></div>
            <div className={`modal-content ${animationClass === 'in' ? 'fade-in-modals' : animationClass === 'out' ? 'fade-out-modals' : ''} ${isModalFullScreen ? 'modal-fullscreen' : ''}`} onAnimationEnd={handleAnimationEnd}>
                {children}
            </div>
        </div>
    );
};

export default Modal;
